

import { useState, useEffect   } from 'react';
import debounce from 'lodash.debounce';


export function InputText(props)
{       
    //const [error, setError] = useState(false);
    const [required, setRequired] = useState(props.required);
    const [type, setType] = useState(props.type);
    const [value, setValue] = useState(props.value);
    const [className, setClassName] = useState(props.className);
    const [placeholder, setPlaceholder] = useState(props.placeholder);
    const [error, setError] = useState(false);
    const [imgC, setImgC] = useState(null);
    const [val, setVal] = useState(props.value);
    const [onShow, setOnShow] = useState(false);
    
    const handleInputChange = debounce((value) => {
        // Tutaj umieść kod, który ma być wykonany po zaprzestaniu pisania
        console.log('Użytkownik przestał pisać:', value);
      }, 5000);

      if(value!=props.value)
      {
        setValue(props.value);
        
      }

   

    //var name = event.target.getAttribute('name'); 
    //var value = event.target.value; 

    const sprawdzEmail = (email) => {
        
        if(email==null) return true;
        if(email.length==0) return true;
        
        const emailRegex = /^[^\s@]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        return emailRegex.test(email);
    }

    const sprawdzDlugosc = (string) => {
        
        if(props.length===undefined) return true;
        if(string.length!=props.length) return false; else return true;
    }
    
    const sprawdzNIP = (nip) => {
        
        if(nip==null) return true;
        if(nip.length==0) return true;
        
        
        // Sprawdzenie, czy NIP składa się z 10 cyfr
        if (!/^\d{10}$/.test(nip)) {
          return false;
        }
      
        // Wagi dla poszczególnych cyfr NIP-u
        const wagi = [6, 5, 7, 2, 3, 4, 5, 6, 7];
      
        // Konwersja NIP-u na tablicę cyfr
        const cyfry = nip.split('').map(Number);
      
        // Obliczenie sumy ważonej
        let suma = 0;
        for (let i = 0; i < 9; i++) {
          suma += cyfry[i] * wagi[i];
        }
      
        // Obliczenie reszty z dzielenia przez 11
        const reszta = suma % 11;
        
        return reszta === cyfry[9];
    }
    
    const sprawdzTelefon = (number) => {
        
        if(number==null) return true;
        if(number.length==0) return true;

        const regexPhone = /^[+\d]+$/;

        return regexPhone.test(number);
    }
    
    const sprawdzKodPocztowy = (post_code) => {
        
        const regexPostCode = /^\d{2}-\d{3}$/;
        return regexPostCode.test(post_code);
    }
    
    const sprawdzNumer = (number) => {
        
        const regexNumer = /^\d+$/;
        return regexNumer.test(number);
    }

    var imgx = null;


    const checkAndSetValue = (event) => {

        var val = event.target.value; 

        //if(val==null) val ='';

        setValue(val);
        
        var error = false;

        if(required=='true')
        {
            if(val.length==0)
            {   
                error=true;
            }
        }

        if(type=='email')
        {
            if(!sprawdzEmail(val)) error=true;
        }

        if(type=='nip')
        {   
            if(!sprawdzNIP(val)) error=true;
        }
        
        
        
        if(type=='phone')
        {
            if(!sprawdzTelefon(val)) error=true;
        }
        
        if(type=='post_code')
        {
            if(!sprawdzKodPocztowy(val)) error=true;
        }

        if(type=='number')
        {   
            if(!sprawdzNumer(val)) error=true;
        }

        
        if(props.length!==undefined)
        {   
            if(!sprawdzDlugosc(val)) error=true;
        }

        if(error==true)
        {   
            props.changeValue(props.name,val,'invalid');
            setClassName(props.className + ' error_input');
            setError(true);
            //setImgC(input_error);
        }

        if(error==false)
        {
            props.changeValue(props.name,val,'valid');
            setClassName(props.className + ' ok_input');
            setError(false);
            //setImgC(input_check);
        }

        
        
    }
    
    const checkValue = () => {

        var val = props.value;    
       
        if(val==null) val ='';

        var error = false;

        if(required=='true')
        {
            if(val.length==0)
            {   
                error=true;
            }
        }

        if(type=='nip')
        {
            if(!sprawdzNIP(val)) error=true;
        }
        
        if(type=='email')
        {
            if(!sprawdzEmail(val)) error=true;
        }
        
        if(type=='phone')
        {
            if(!sprawdzTelefon(val)) error=true;
        }
        
        if(type=='post_code')
        {
            if(!sprawdzKodPocztowy(val)) error=true;
        }

        if(type=='number')
        {
            if(!sprawdzNumer(val)) error=true;
        }

        if(props.length!==undefined)
        {   
            if(!sprawdzDlugosc(val)) error=true;
        }

        if(error==true)
        {   
            
            setClassName(props.className + ' error_input');
            setError(true);
            //setImgC(input_error);
            props.changeValue(props.name,val,'invalid');
        }
    
        if(error==false)
        {
            
            //setClassName(props.className + ' ok_input');
            setError(false);
            //setImgC(input_check);
            props.changeValue(props.name,val,'valid');
        }
    }

    
    useEffect(() => {
        
        if(onShow==true)
        {
            checkValue();
            setOnShow(false);
        }
        else
        {
            if(val != props.value && props.value != undefined)
                {   
                    if(error==true )
                        props.changeValue(props.name,props.value,'invalid');
                    else
                        props.changeValue(props.name,props.value,'valid');
        
                    setVal(props.value);
                    setOnShow(false);
        
                }
        }
        
        
        
        
      
            
    });

    var icon = null;

    //if(imgC!=null) icon = <img className="input_status" src={imgC} />;
       
    return (
        <fieldset>
            <input type='text'  name={props.name} placeholder={placeholder} className={className} onChange={checkAndSetValue}  value={value}/>
            {icon}
        </fieldset>
    )


    
}

